var map = {
	"./selfServe/loginSessionsConfiguration.json": 79433,
	"./selfServe/sample.json": 84977,
	"./selfServe/sample1.json": 24908,
	"modules/uiBuilder/templates/selfServe/loginSessionsConfiguration.json": 79433,
	"modules/uiBuilder/templates/selfServe/sample.json": 84977,
	"modules/uiBuilder/templates/selfServe/sample1.json": 24908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54751;